export enum PortalEventName {
    userAuthenticated = 'user_authenticated',
    pageVisited = 'page_visited',
}
